<template>
	<BaseIcon
		name="mono/chevron-down"
		:style="{width: `${size}px`, height: `${size}px`}"
		class="flex-shrink-0 transform inline-block"
		:class="[horizontal ? ['rotate-90', {'-rotate-90': flip}] : ['rotate-0', {'rotate-180': flip}]]"
	/>
</template>

<script>
export default {
	props: {
		flip: Boolean,
		horizontal: Boolean,
		size: {type: String, default: '14'},
	},
}
</script>
